// text-formatting-input.component.ts
import { Component, OnInit, OnDestroy, forwardRef, Input, Output, EventEmitter } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-text-formatting-input',
  templateUrl: './text-formatting-input.component.html',
  styleUrls: ['./text-formatting-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextFormattingInputComponent),
      multi: true,
    },
  ],
})
export class TextFormattingInputComponent implements OnInit, OnDestroy, ControlValueAccessor {
  editor!: Editor;
  toolbar!: Toolbar;
  @Input() value: string = '';
  @Input() isDisabled = false;


  @Input() inputHeight: string = '';

  private onChangeFn = (value: any) => {};
  private onTouched: () => void = () => {};
  @Output() changeEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {
    this.editor = new Editor();

    this.toolbar = [
      ['bold', 'italic', 'underline', 'format_clear'],
      ['align_left', 'align_center', 'align_right', 'align_justify'],
      ['background_color', 'text_color'],
      ['undo', 'redo'],
    ];
  }

  writeValue(value: string): void {
    if (this.value !== value) {
      this.value = value || '';
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onChange(value: string): void {
    if (this.value !== value) {
      this.value = this.checkHtmlEmpty(value);      
      this.onChangeFn(this.value);
      this.onTouched();
      this.changeEmitter.emit(this.value);
    }
  }

  checkHtmlEmpty(value:string):string {
    let flag = value.replace(/<[^>]*>/g, '').trim();
    if(!flag){
      return '';
    }else{
      return value
    }
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
